import { CSSProperties } from 'react';

export const COMPACT_MODAL_CONTENT_STYLE: CSSProperties = {
  width: '-webkit-fill-available',
  height: 'fit-content',
  maxWidth: 350,
  border: 'none',
  margin: '20px auto',
  justifySelf: 'center',
};
